import { createFileRoute } from '@tanstack/react-router';

import { CertificationDefinitionsAdmin } from '@/features/certifications/CertificationDefinitionsAdmin';

export const Route = createFileRoute('/_authenticated/certification-definitions/')({
  component: CertificationDefinitionsAdmin,
});
